<!--
 * @Description:市场营销-线索管理联系人，投放记录联系人  props edisabled 不可以编辑
   /marketing/clueTracking/view 线索跟踪详情
   /marketing/clueReleaseRecord/view 线索投放记录详情
   /marketing/clueManage/view 线索管理列表详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-07 17:04:58
 * @LastEditors: cxh
-->
<template>
  <cos-table
    :columns="
      disabled
        ? columns
        : [
            ...columns,
            {
              title: '操作',
              dataIndex: 'action',
              fixed: 'right',
              width: 160
            }
          ]
    "
    @fetch="fetch"
    v-bind="$attrs"
    serial
    ref="table"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" v-permission="permissionPage?.edit"> 编辑 </a-button>
        <a-button type="link" @click="handleDelete(record)" v-permission="permissionPage?.del"> 删除 </a-button>
        <a-button
          type="link"
          @click="handlePush(record)"
          v-permission="permissionPage?.push"
          v-if="props.trackAcceptorClueId !== undefined && props.trackAcceptorClueId !== null"
        >
          推送
        </a-button>
      </template>
    </template>
  </cos-table>
  <EditModal ref="editModalRef" @success="refresh" />
</template>
<script setup lang="ts">
import { ref } from 'vue'
import type { PropType } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { zbuContactList, zbuContactDelete, zbuContactPush } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import EditModal from './editModal.vue'
import type { ClueManage } from '@/typings/api/marketingManage'
const route = useRoute()
const table = ref()
const loading = ref(false)
const editModalRef = ref()
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object as PropType<ClueManage['contact'][]>
  },
  contactRefId: {
    type: String
  },
  trackAcceptorClueId: {
    type: String
  },
  permissionPage: {
    type: Object
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.clueId) {
    zbuContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// const success = () => {
//   table.value.fetch()
// }
// // 新增
// const handleAdd = () => {
//   editModalRef.value.toggle()
// }
// 编辑
const handleEdit = (row: ClueManage['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: ClueManage['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      zbuContactDelete({
        contactId: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}

const handlePush = (row: ClueManage['contact']) => {
  loading.value = true
  zbuContactPush({
    contactId: row.id,
    contactRefId: row.contactRefId,
    trackAcceptorClueId: props.trackAcceptorClueId
  })
    .then((res) => {
      table.value.fetch()
      message.success('推送成功')
    })
    .finally(() => {
      loading.value = false
    })
}

const columns = ref([
  {
    title: '联系人名称',
    dataIndex: 'name'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum
  },
  {
    title: '角色',
    dataIndex: 'jobRole',
    dicData: dataConfig.linkRoleTypeEnum
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  {
    title: '微信号',
    dataIndex: 'wechat'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq'
  },
  {
    title: '固定电话',
    dataIndex: 'tel'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  }
])
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default { name: 'ContactsTable' }
</script>
